/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { catchError, map, Observable, of, retry, tap } from 'rxjs';
import { IClaimFilingIndicator } from 'src/app/shared/interfaces/claim/claim.interface';
import { ClaimsGQLService } from 'src/app/shared/services/claims/claims.graphql.service';

@Component({
  selector: 'claim-filing-indicators-select',
  templateUrl: './claim-filing-indicators-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => {
        return ClaimFilingIndicatorsSelectComponent;
      }),
      multi: true,
    },
  ],
})
export class ClaimFilingIndicatorsSelectComponent
  implements ControlValueAccessor, OnInit
{
  @Input() disabled = false;
  @Input() placeholder = 'Select Filing Indicator';
  @Input() required = false;

  claimFilingIndicators$: Observable<IClaimFilingIndicator[]>;

  value = '';

  isLoading = true;

  onChange?: any;
  onTouched?: any;

  //#region ControlValueAccessor

  constructor(private claimsGQLService: ClaimsGQLService) {}

  ngOnInit() {
    this.claimFilingIndicators$ = this.claimsGQLService
      .getClaimFilingIndicators()
      .pipe(
        tap(() => {
          return (this.isLoading = false);
        }),
        map((response) => {
          return response.nodes;
        }),
        retry(2),
        catchError(() => {
          return of([]);
        }),
      );
  }

  writeValue(value: any) {
    this.value = value ? value : '';
    this.onValueChanged();
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  //#endregion

  onValueChanged() {
    this.onChange(this.value);
  }
}
